import { render, staticRenderFns } from "./AreaSessionFormItem.vue?vue&type=template&id=0ddecb30&"
import script from "./AreaSessionFormItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AreaSessionFormItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AreaSessionFormItem.vue?vue&type=style&index=0&id=0ddecb30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports